import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import withLoader from 'components/organisms/withLoader';
import { format } from 'date-fns';
import { API_MESSAGES_RESPONSE } from 'services/dataService/ccmResources';
import Pagination from 'components/molecules/paginationTransition';
import useTable from 'utils/useTable';
import { useParams } from 'react-router-dom';

const DATE_FORMAT = 'yyyy-MM-dd HH:mm:s';
const EACH_MESSAGE_COUNT = 5;
const SMS_RESPONSES_AND_DOCTOR_MESSAGES_COUNT = EACH_MESSAGE_COUNT * 2;
const SmsActivity = () => {
  const { patientGuid } = useParams();

  const dates = useSelector((state) => state.ccmPatientDetails.dates);

  const {
    data: { items },
    count,
    loading,
    page,
    setPage,
    setFilters,
  } = useTable(
    API_MESSAGES_RESPONSE,
    EACH_MESSAGE_COUNT,
    { patientGuid },
    {
      makeInitialRequest: false,
    },
  );

  useEffect(() => {
    if (dates.length > 1) {
      const startTime = format(dates[0], DATE_FORMAT);
      const endTime = format(dates[1], DATE_FORMAT);
      setFilters({ patientGuid, startTime, endTime });
    }
  }, [dates, patientGuid]);

  return (
    <>
      <h3 className="ccm-table-section__h4">SMS Activity Logged</h3>
      {withLoader(
        loading,
        <>
          <div className="table-outer table-custom-scrollbar">
            <table cellSpacing="0" cellPadding="0" className="table-border">
              <thead>
                <tr>
                  <th>Date/Time</th>
                  <th>To</th>
                  <th>From</th>
                  <th>SMS Text</th>
                </tr>
              </thead>
              <tbody>
                {!!items.length &&
                  items.map((el, index) => (
                    <tr key={index}>
                      <td>
                        {el.createdAt
                          ? format(new Date(el.createdAt), 'LLL dd yyyy p')
                          : ''}
                      </td>
                      <td>{el.to}</td>
                      <td>{el.from}</td>
                      <td>
                        <div className="note">{el.message}</div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="ccm-table-section__pagination">
            <Pagination
              title=""
              page={page}
              pageTotal={items.length}
              itemsPerPage={SMS_RESPONSES_AND_DOCTOR_MESSAGES_COUNT}
              total={count}
              handleFirstClick={() => setPage(1)}
              handleLastClick={() =>
                setPage(
                  Math.ceil(count / SMS_RESPONSES_AND_DOCTOR_MESSAGES_COUNT),
                )
              }
              handlePrevClick={() => setPage(page - 1)}
              handleNextClick={() => setPage(page + 1)}
              handleGoToPage={(numberPage) => setPage(numberPage)}
            />
          </div>
        </>,
      )}
    </>
  );
};

export default SmsActivity;
